/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-icon{color:#adb9ce}.login .info .title{color:#463e3e;font-size:22px;font-weight:700}.login .info .details{color:#8d8d8d}.login .login-form .btn-green{background:no-repeat padding-box #00a9a5;color:#fff}.login .login-form .btn{border-radius:8px;min-height:40px}.login .form-group{margin-bottom:.1rem}"];
export { styles as styles };
